import React from 'react';

const svgProps = { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };

const HomeIcon = () => (
  <svg {...svgProps}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
);

const OverviewIcon = () => (
  <svg {...svgProps}><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>
);

const StudentsIcon = () => (
  <svg {...svgProps}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
);

const ClassesIcon = () => (
  <svg {...svgProps}><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg>
);


const SavedRunsIcon = () => (
  <svg {...svgProps}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" /></svg>
);

const GradesIcon = () => (
  <svg {...svgProps}><line x1="4" y1="9" x2="20" y2="9" /><line x1="4" y1="15" x2="20" y2="15" /><line x1="10" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="14" y2="21" /></svg>
);

const UsersIcon = () => (
  <svg {...svgProps}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
);

const AdminIcon = () => (
  <svg {...svgProps}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
);

const FactorsIcon = () => (
  <svg {...svgProps}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>
);


export const navigation = [
  { label: 'Home', icon: HomeIcon, color: '#6366f1', to: '/' },
  { label: 'Students', icon: StudentsIcon, color: '#06b6d4', to: '/roster' },
  { label: 'Grades', icon: GradesIcon, color: '#10b981', to: '/grades' },
  { label: 'Classes', icon: ClassesIcon, color: '#f59e0b', to: '/classes' },
  { label: 'Planner', icon: OverviewIcon, color: '#8b5cf6', to: '/overview' },
  { label: 'Saved Runs', icon: SavedRunsIcon, color: '#6366f1', to: '/saved-runs' },
  { label: 'Factors', icon: FactorsIcon, color: '#ec4899', to: '/factors' },
  { label: 'Users', icon: UsersIcon, color: '#64748b', to: '/users', permission: 'user.manage' },
  { label: 'Admin', icon: AdminIcon, color: '#dc2626', to: '/admin', permission: 'platform.admin' }
];

export const navigationSections = [
  {
    items: [
      { label: 'Home', icon: HomeIcon, color: '#6366f1', to: '/' },
      { label: 'Students', icon: StudentsIcon, color: '#06b6d4', to: '/roster' },
      { label: 'Grades', icon: GradesIcon, color: '#10b981', to: '/grades' },
      { label: 'Classes', icon: ClassesIcon, color: '#f59e0b', to: '/classes' },
      { label: 'Planner', icon: OverviewIcon, color: '#8b5cf6', to: '/overview' },
      { label: 'Saved Runs', icon: SavedRunsIcon, color: '#6366f1', to: '/saved-runs' },
      { label: 'Factors', icon: FactorsIcon, color: '#ec4899', to: '/factors' },
      { label: 'Users', icon: UsersIcon, color: '#64748b', to: '/users', permission: 'user.manage' },
      { label: 'Admin', icon: AdminIcon, color: '#dc2626', to: '/admin', permission: 'platform.admin' }
    ]
  }
];

export const filterOptions = [
  { value: 'all', label: 'All students' },
  { value: 'locked', label: 'Locked' },
  { value: 'conflict', label: 'Conflict' },
  { value: 'missing-friends', label: 'Missing friends' },
  { value: 'ready', label: 'Ready' }
];
